var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneClickIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.009,
    height: 49.008,
    viewBox: "0 0 49.009 49.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Click",
    d: "M27.5,52.008a1.677,1.677,0,0,1-.242-.018,1.635,1.635,0,0,1-1.323-1.147l-9.8-32.672a1.634,1.634,0,0,1,2.034-2.034l32.672,9.8a1.633,1.633,0,0,1,.437,2.924l-8.143,5.429,8.392,8.393a1.632,1.632,0,0,1,0,2.31L45,51.529a1.632,1.632,0,0,1-2.31,0l-8.393-8.392L28.864,51.28a1.635,1.635,0,0,1-1.36.728Zm6.534-13.069a1.632,1.632,0,0,1,1.155.479l8.647,8.647,4.224-4.224-8.646-8.647a1.634,1.634,0,0,1,.249-2.515l6.913-4.608L20.14,20.139l7.932,26.44,4.608-6.913a1.631,1.631,0,0,1,1.2-.72q.08-.007.16-.007ZM12.323,12.323a1.633,1.633,0,0,0,0-2.31L9.056,6.746a1.633,1.633,0,0,0-2.31,2.31l3.267,3.267a1.633,1.633,0,0,0,2.31,0ZM11.168,17.7a1.634,1.634,0,0,0-1.634-1.634h-4.9a1.634,1.634,0,0,0,0,3.267h4.9A1.634,1.634,0,0,0,11.168,17.7ZM9.056,28.659l3.267-3.267a1.633,1.633,0,0,0-2.31-2.31L6.746,26.349a1.633,1.633,0,1,0,2.31,2.31ZM25.392,12.323l3.267-3.267a1.633,1.633,0,0,0-2.31-2.31l-3.267,3.267a1.633,1.633,0,1,0,2.31,2.31ZM19.336,9.534v-4.9a1.634,1.634,0,1,0-3.267,0v4.9a1.634,1.634,0,1,0,3.267,0Z",
    transform: "translate(-3 -3)",
    fill: "#7b7bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClickIntegration);
export default __webpack_public_path__ + "static/media/one-click-integration.45754151f3791eabfd7a9b8e9b7adfae.svg";
export { ForwardRef as ReactComponent };